import { createSlice } from "@reduxjs/toolkit";

const initialState = {
   teachers:[]
}

const teacherSlice = createSlice({
    name: "teacher",
    initialState,
    reducers: {
        setteacher: (state, action) => {
            state.teachers = action.payload;
        },

        removeteacher: (state, action) => {
            const { id } = action.payload;
            state.teachers = state.teachers.filter((item) => item.id !== id);
          }
       
    }
});

export const { setteacher,removeteacher } = teacherSlice.actions;
export default teacherSlice.reducer;